import { z } from "zod";

export type Transaction = z.infer<typeof TransactionSchema>;

export const TransactionSchema = z.object({
	// mandatory
	amount: z.number(),
	caid: z.string(),
	responseCode: z.string(),
	responseText: z.string(),
	transactionUuid: z.string(),

	// optional
	aid: z.string().optional(),
	applicationName: z.string().optional(),
	authCode: z.string().optional(),
	bin: z.string().optional(),
	cardMedia: z
		.union([
			z.literal("CNP"),
			z.literal("ICC"),
			z.literal("MANUAL"),
			z.literal("MSR"),
			z.literal("NFC"),
			z.literal("PICC"),
		])
		.optional()
		.catch(undefined),
	cardholderUuid: z.string().optional(),
	catid: z.string().optional(),
	currency: z.string().optional(),
	cvm: z
		.union([
			z.literal("CD_CVM"),
			z.literal("CVM_FAILED"),
			z.literal("NO_CVM"),
			z.literal("OFFLINE_PIN"),
			z.literal("ONLINE_PIN"),
			z.literal("PIN_AND_SIGNATURE"),
			z.literal("SIGNATURE"),
			z.literal("UNKNOWN_CVM"),
		])
		.optional()
		.catch(undefined),
	emvTagsPrint: z.string().optional(),
	panMasked: z.string().optional(),
	receiptLink: z.string().optional(),
	receiptText: z.string().optional(),
	rrn: z.string().optional(),
	scheme: z.string().optional(),
	sessionUuid: z.string().optional(),
	surchargeAmount: z.number().optional(),
	timestampLocal: z.string().datetime({ offset: true }).optional(),
	taxAmount: z.number().optional(),
	tipAmount: z.number().optional(),
});
